/**
 * Simple throttle function lifted from https://blog.webdevsimplified.com/2022-03/debounce-vs-throttle/
 * @param {Function} cb callback to be throttled, called after delay
 * @param {number} delay in ms
 * @returns the throttled callback
 */
export default function throttle(cb, delay = 1000) {
  let shouldWait = false;
  let waitingArgs;
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      cb(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };

  return (...args) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }

    cb(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}
